










































































































































































import { Vue, Component, Watch }    from 'vue-property-decorator'
import { mapGetters, mapState }               from 'vuex'
import { FontAwesomeIcon }          from '@fortawesome/vue-fontawesome'

import { Ability }                  from '@/types/Ability'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import { formatNumber, formatDate, formatStringDate } from '@/utils/helpers'
import { getTypeAjustement } from '@/types/EpreuveCorrectionResultat'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import { EtatRemonteNote, getEtatRemonteNoteLibelle } from '@/types/ConcourPhase'
import _ from 'lodash'


/**
 * Composant contenant l'ensemble des epreuveCorrectionResultats
*/
@Component({
    computed: {
        ...mapGetters('epreuveCorrectionResultat', ['epreuveCorrectionResultats', 'loading', 'totalRows', 'lastPage', 'totalPage', 'error']),
        ...mapGetters('concourPhase', ['phaseAjustementCompteurs']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id'])
    },
    components: {
        ExaGenericTable,
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})

export default class EpreuveCorrectionResultats extends Vue
{
    showModalEditionCandidat?:          boolean = false
    showModalEditionCommentCandidat?:   boolean = false
    formatDate = formatDate
    getTypeAjustement = getTypeAjustement
    sessionSelect: any = null
    tableLoading = false

    showValideAjustements = false
    firstLoading = true
    EtatRemonteNote = EtatRemonteNote

    Ability = Ability

    getEtatRemonteNoteLibelle = getEtatRemonteNoteLibelle

    // Ensemble des colonnes du tableau de epreuveCorrectionResultats

    genericfields = [
        { key: 'epreuve_correction.phase.name', label: 'Phase', sortable: true, class: '', type: 'text' },
        { key: 'epreuve_correction.concours.name', label: 'Filière', sortable: true, class: '', type: 'text' },
        { key: 'epreuve_correction.name', label: 'Épreuve', sortable: true, class: '', type: 'text' },
        { key: 'correction_finished_at', label: 'Notation terminée', sortable: true, class: 'text-center', type: 'text' },
        { key: 'moyenne_notes_brutes', label: 'Moyenne notes brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ecart_type_notes_brutes', label: 'Écart type notes brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ajustement', label: 'Étape d\'ajustement', sortable: true, class: 'text-center', type: 'text' },
        { key: 'moyenne_notes_finales', label: 'Moyenne notes finales', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ecart_type_notes_finales', label: 'Écart type notes finales', sortable: true, class: 'text-center', type: 'text' },
        // { key: 'ajustements_params.arrondi', label: 'Arrondi', sortable: true, class: '', type: 'text' },
        { key: 'notes_finalisees_validated_at', label: 'Notes finalisées', sortable: true, class: 'text-center', type: 'text' },
        { key: 'enterEpreuve', label: '', sortable: false, class: '', type: 'action' }
    ]

    sortBy          = '';
    sortDesc        = false;
    sortDirection   = 'asc';
    filter          = '';
    filterOn        = [];
    stickyHeader    = true;

    filtres:    any         = []
    dataForTab: Array<any>  = []
    filieres: Array<any> = []
    dicoPhaseFilieres: { [indice: string]: { phase: any; concours: Array<any>; libelle: string; filiere: string; tableAjustements: Array<string>; nbEpreuves: number; nbEpreuvesAjustementValide: number; liste_etapes_ajustement: {[indice: string]: {libelle: string; epreuves: Array<any>} }}} = {}

    // Spécifique à la partie validation des ajustements. Ne récupère que les phasesFilières qui comprennent des ajustements.
    dicoPhaseFilieresValidation: { [indice: string]: { phase: any; concours: Array<any>; libelle: string; filiere: string; tableAjustements: Array<string>; nbEpreuves: number; nbEpreuvesAjustementValide: number; liste_etapes_ajustement: {[indice: string]: {libelle: string; epreuves: Array<any>} }}} = {}

    nb_filieres_valide = 0
    nb_filieres = 0
    params: any = null
    phase_concours_selected: { phase: any; concours: Array<any>; libelle: string; filiere: string;tableAjustements: Array<string>; nbEpreuves: number; nbEpreuvesAjustementValide: number; liste_etapes_ajustement: {[indice: string]: {libelle: string; epreuves: Array<any>} }} | null = null
    etape_ajustement_selected = ''
    validationEnCours = false
    showRemonteNotes = false
    showButtonStartViatiqueResult =  false

    dataRemonteNote: any = {}
    loadEtatRemonteEnCours = false
    remontEnCours = false

    @Watch('epreuveCorrectionResultats')
    getCompteurs () {
        this.$store.dispatch('concourPhase/getConcourPhaseAjustementCompteurs')
    }

    @Watch('user_session_id')
    refreshInterface () {
        this.load()
    }

    openRemonteNotes () {
        this.showRemonteNotes = true
        this.showButtonStartViatiqueResult = false
        this.showButtonStartViatiqueResult = true
        this.getdataRemonteNote()
    }

    getdataRemonteNote() {
        this.loadEtatRemonteEnCours = true
        this.dataRemonteNote = {}
        this.remontEnCours = false
        this.$store.dispatch('concourPhase/getViatiqueResultState', { session_id: this.sessionSelect.id }).then((response) => {
            for (let i = 0; i < response.data.data.length; i++) {
                if (!this.dataRemonteNote[response.data.data[i].entity_id]) {
                    this.dataRemonteNote[response.data.data[i].entity_id] = {}
                }
                this.dataRemonteNote[response.data.data[i].entity_id] = response.data.data[i]
            }
            for (const key in this.dataRemonteNote) {
                if (this.dataRemonteNote[key].message) {
                    this.dataRemonteNote[key].message = JSON.parse(this.dataRemonteNote[key].message)
                    // console.log('----------------this.dataRemonteNote[key].message----------------------')
                    // console.log(this.dataRemonteNote[key].message[1])
                    // console.log('--------------------------')
                }
                if (this.dataRemonteNote[key].etat === EtatRemonteNote.ETAT_EN_COURS) {
                    this.remontEnCours = true
                }
            }
            this.loadEtatRemonteEnCours = false
        })
    }

    startViatiqueResult () {
        this.loadEtatRemonteEnCours = true
        this.dataRemonteNote = {}
        this.$store.dispatch('concourPhase/startViatiqueResultState', { session_id: this.sessionSelect.id }).then(() => {
            this.getdataRemonteNote()
        })
    }

    closeRemonteNotes () {
        this.showRemonteNotes = false
    }

    canValideNotesFinales () {
        if (this.phase_concours_selected && this.phase_concours_selected.liste_etapes_ajustement) {
            if (this.phase_concours_selected.nbEpreuves > 0 &&
                this.phase_concours_selected.nbEpreuvesAjustementValide === this.phase_concours_selected.nbEpreuves) {
                return true
            }
        }
        return  false
    }

    canInValideNotesFinales () {
        if (this.phase_concours_selected) {
            const concourPhase = this.$store.getters['concourPhase/getConcourPhaseByConcourIdAndPhaseId'](this.phase_concours_selected.concours[0].id, this.phase_concours_selected.phase.id)
            if (concourPhase && concourPhase.ajustements_validated_at) {
                return true
            }
        }
        return  false
    }

    confirmValidIsDisabled () {
        if (this.validationEnCours || !this.phase_concours_selected || (this.phase_concours_selected && !this.phase_concours_selected.liste_etapes_ajustement)) {
            return true
        }
        if (this.etape_ajustement_selected !== 'valide_notes_finales' && this.etape_ajustement_selected !== 'invalide_notes_finales' && (this.phase_concours_selected && (!this.phase_concours_selected.liste_etapes_ajustement ||
        Object.keys(this.phase_concours_selected.liste_etapes_ajustement).length === 0 ||
        !this.phase_concours_selected.liste_etapes_ajustement[this.etape_ajustement_selected] ||
        !this.phase_concours_selected.liste_etapes_ajustement[this.etape_ajustement_selected].epreuves ||
        this.phase_concours_selected.liste_etapes_ajustement[this.etape_ajustement_selected].epreuves.length === 0))) {
            return true
        }
        return false
    }

    openValideAjustements () {
        this.$store.state.epreuveCorrectionResultat.error = null
        this.phase_concours_selected = null
        this.etape_ajustement_selected = ''

        this.showValideAjustements = true
        this.phase_concours_selected = null
    }

    cancelValideAjustements () {
        this.showValideAjustements = false
        this.phase_concours_selected = null
        this.etape_ajustement_selected = ''
    }

    validAjustements () {
        this.validationEnCours = true
        if (this.phase_concours_selected) {
            const concourPhase = this.$store.getters['concourPhase/getConcourPhaseByConcourIdAndPhaseId'](this.phase_concours_selected.concours[0].id, this.phase_concours_selected.phase.id)
            if (concourPhase) {
                let payload: any
                if (this.etape_ajustement_selected === 'valide_notes_finales') {
                    payload = {
                        concourPhase_id: concourPhase.id,
                        validate: 1
                    }
                } else if (this.etape_ajustement_selected === 'invalide_notes_finales') {
                    payload = {
                        concourPhase_id: concourPhase.id,
                        validate: 0
                    }
                } else {
                    payload = {
                        concourPhase_id: concourPhase.id,
                        ajustement_name: this.etape_ajustement_selected,
                        validate: 1

                    }
                }
                const idInfo = 't_info_' + Math.random()
                const infosToaster = {
                    id: idInfo,
                    toaster: 'b-toaster-top-right',
                    variant: 'primary',
                    noCloseButton: true,
                    fade: true,
                    noAutoHide: true
                }

                this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
                this.$store.dispatch('concourPhase/updateConcourPhaseAjustement', payload).then(() => {
                    this.$bvToast.hide(idInfo)
                    const idSucces = 't_succes_' + Math.random()
                    const succesToaster = {
                        id: idSucces,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        noCloseButton: true,
                        fade: true,
                        autoHideDelay: 5000
                    }
                    this.$bvToast.toast('Enregistrement terminé.', succesToaster)
                    this.showValideAjustements = false
                    this.validationEnCours = false
                    this.tableLoading = true
                    this.$store.dispatch('concourPhase/getConcourPhases', { 'filter-ajustement': 1 }).then(() => {
                        this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultats', this.params).then(() => {
                            this.tableLoading = false
                            this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats)
                        }).catch((error) => {
                            console.log('ko:' + error)
                        })
                    }).catch((error) => {
                        console.log('ko:' + error)
                    })
                }).catch((error) => {
                    this.$bvToast.hide(idInfo)
                    console.log('ko:' + error)
                    this.validationEnCours = false
                })
            }
        }
    }

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setDataForGenericTab(poData: any, isLoadMore = false) {
        if (!isLoadMore) {
            this.dataForTab = []
        }
        if (poData) {
            this.filieres = []
            const dicoFilieres: { [concour_id: string]: { total: number; valides: number} } = {}
            this.dicoPhaseFilieres = {}

            for (const result of poData) {
                // const nameEpreuveCorrection = '( ' + result.id + ' ) ' + result.epreuve_correction.name
                const nameEpreuveCorrection = result.epreuve_correction.name

                const phaseName = result.epreuve_correction && result.epreuve_correction.phase && result.epreuve_correction.phase.name ? result.epreuve_correction.phase.name : '-'
                const phase = result.epreuve_correction && result.epreuve_correction.phase ? result.epreuve_correction.phase : '-'

                let filiere = '-'
                const concours = result.epreuve_correction.concours.filter((c: any) => c.session_id === this.$store.getters['auth/user_session_id'])
                if (result.epreuve_correction && concours) {
                    for (const concourkey in concours) {
                        const concourTemp = concours[concourkey]

                        if (concourTemp) {
                            if (!dicoFilieres[concourTemp.id]) {
                                this.filieres.push(concourTemp)
                                dicoFilieres[concourTemp.id] = {
                                    total: 0,
                                    valides: 0
                                }
                            }
                            dicoFilieres[concourTemp.id].total++
                            if (result.notes_finalisees_validated_at) {
                                dicoFilieres[concourTemp.id].valides++
                            }

                            if (filiere === '-') {
                                filiere = ''
                            }
                            if (filiere.length > 0 && concourTemp) {
                                filiere += ', '
                            }
                            filiere += concourTemp ? concourTemp.name : ''
                        }
                    }
                }
                if (!this.dicoPhaseFilieres[phase.id + '-' + filiere]) {
                    this.dicoPhaseFilieres[phase.id + '-' + filiere] = {
                        phase: phase,
                        concours: result.epreuve_correction.concours,
                        libelle: phaseName + ' - ' + filiere,
                        filiere: filiere,
                        liste_etapes_ajustement: {},
                        tableAjustements: [],
                        nbEpreuves: 0,
                        nbEpreuvesAjustementValide: 0
                    }
                }


                const puce_correction_fini = []
                let class_saisie_examinateur = 'text-tertiary'
                if (result.correction_finished_at) {
                    class_saisie_examinateur = 'text-success'
                }
                puce_correction_fini.push({ name:'circle', class: class_saisie_examinateur })
                const title_correction_fini = result.correction_finished_at ? formatStringDate(result.correction_finished_at) : ''

                const moyenne_notes_brutes = result.moyenne_notes_brutes ? formatNumber(result.moyenne_notes_brutes) : '-'
                const ecart_type_notes_brutes = result.ecart_type_notes_brutes ? formatNumber(result.ecart_type_notes_brutes) : '-' // au centieme
                const moyenne_notes_finales = result.moyenne_notes_finales ? formatNumber(result.moyenne_notes_finales) : '-'
                const ecart_type_notes_finales = result.ecart_type_notes_finales ? formatNumber(result.ecart_type_notes_finales) : '-'
                // const arrondi = result.ajustements_params.arrondi ? result.ajustements_params.arrondi : '-'

                let currentAjustement = ''
                let etape_ajustement = getTypeAjustement(result.ajustement).libelle // Init par défaut à "Pas d\'ajustement"

                /** **************************************************************************************************************************
                 * DEBUT - Partie spécifique aux PhaseFilières comprenant des ajustements. Dans ce cas, on init tout ce qui concerne les ajustements
                 * Ces filières ne sont donc pas soumises non plus à la validation d'ajustement.
                 * ***************************************************************************************************************************/
                if (phase.ajustements) {
                    for (const key in result.ajustements_params) {
                        if (!this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.includes(key)) {
                            this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.push(key)
                        }
                    }

                    if (result.ajustement) {
                        if (this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.indexOf(result.ajustement) + 1 <  this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.length) {
                            currentAjustement =  this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements[this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.indexOf(result.ajustement) + 1]
                        } else {
                            currentAjustement = result.ajustement
                        }
                    } else if (result.correction_finished_at) {
                        currentAjustement =  this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements[0]
                    }

                    etape_ajustement = (result.ajustement ? (this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.indexOf(result.ajustement) + 1) + '. ' : '')  +  getTypeAjustement(result.ajustement).libelle // 'Pas d\'ajustement'
                    if (!this.dicoPhaseFilieres[phase.id + '-' + filiere].liste_etapes_ajustement[currentAjustement] && currentAjustement !== '') {
                        this.dicoPhaseFilieres[phase.id + '-' + filiere].liste_etapes_ajustement[currentAjustement] = {
                            libelle: getTypeAjustement(currentAjustement).libelle,
                            epreuves: []
                        }
                    }
                    this.dicoPhaseFilieres[phase.id + '-' + filiere].nbEpreuves++

                    if (currentAjustement !== '') {
                        if (!result.ajustements_params[currentAjustement].validated_at) {
                            this.dicoPhaseFilieres[phase.id + '-' + filiere].liste_etapes_ajustement[currentAjustement].epreuves.push(result)
                        } else if (currentAjustement === this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements[this.dicoPhaseFilieres[phase.id + '-' + filiere].tableAjustements.length - 1]) {
                            this.dicoPhaseFilieres[phase.id + '-' + filiere].nbEpreuvesAjustementValide++
                        }
                    }
                }
                /** **************************************************************************************************************************
                 * FIN - Partie spécifique aux PhaseFilières comprenant des ajustements.
                 * ***************************************************************************************************************************/

                let class_etape_ajustement = 'text-secondary text-center libelle_etape_ajustement'
                const puce_notes_finalisees_validated = []
                let class_notes_finalisees_validated = 'text-tertiary'
                if (phase.ajustements) {
                    if (result.correction_finished_at && result.ajustement && result.ajustement !== '') {
                        class_etape_ajustement = 'text-primary text-center libelle_etape_ajustement'
                    }
                    if (currentAjustement !== '' && result.ajustements_params[currentAjustement].validated_at) {
                        class_etape_ajustement = 'text-success text-center libelle_etape_ajustement'
                    }
                    if (result.notes_finalisees_validated_at) {
                        class_notes_finalisees_validated = 'text-success'
                    }
                } else {
                    // Cas d'une FilierePhase ne comprenant pas d'ajustements.
                    // Dans ce cas, pas d'étape intermédiaire d'ajustement, on check directement si les notes sont validées.
                    if (result.notes_finalisees_validated_at) {
                        class_notes_finalisees_validated = 'text-success'
                    }
                }

                puce_notes_finalisees_validated.push({ name:'circle', class: class_notes_finalisees_validated })
                const title_notes_finalisees_validated = result.notes_finalisees_validated_at ? formatStringDate(result.notes_finalisees_validated_at) : ''

                const puce_enter_epreuve = []
                let class_enter_epreuve = 'fa-lg text-center'
                let enter_epreuve_disabled = true
                if (result.correction_finished_at) {
                    enter_epreuve_disabled = false
                    class_enter_epreuve += ' text-info'
                } else {
                    class_enter_epreuve += ' text-tertiary'
                }
                puce_enter_epreuve.push({ name:'arrow-circle-right', class: class_enter_epreuve })

                const line = [
                    { label: '', item: phaseName, type: 'text', typeAction: null, class: '' },
                    { label: '', item: filiere, type: 'text', typeAction: null, class: '' },
                    { label: 'Epreuve de correction', item: nameEpreuveCorrection, type: 'text', typeAction: null, class: '' },
                    { label: '', item: puce_correction_fini, type: 'icons', typeAction: null, class: 'text-center', title: title_correction_fini },
                    { label: '', item: moyenne_notes_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: ecart_type_notes_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: etape_ajustement, type: 'text', typeAction: null, class: class_etape_ajustement },
                    { label: '', item: moyenne_notes_finales, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: ecart_type_notes_finales, type: 'text', typeAction: null, class: 'text-center' },
                    // { label: '', item: arrondi, type: 'text', typeAction: null, class: '' },
                    { label: '', item: puce_notes_finalisees_validated, type: 'icons', typeAction: null, class: 'text-center', title: title_notes_finalisees_validated },
                    { label: '', item: result.id, icon: 'arrow-circle-right', type: 'action', typeAction: 'detailAjustement', class: class_enter_epreuve, disabled: enter_epreuve_disabled }
                    // { ...phase.ajustements ? { label: '', item: result.id, icon: 'arrow-circle-right', type: 'action', typeAction: 'detailAjustement', class: class_enter_epreuve, disabled: enter_epreuve_disabled } : { label: '', item: '', type: 'text', typeAction: null, class: '' } }
                ]
                this.dataForTab.push(line)
            }

            this.nb_filieres = 0
            this.nb_filieres_valide = 0

            for (const concour_id in dicoFilieres) {
                this.nb_filieres++
                if (dicoFilieres[concour_id].total === dicoFilieres[concour_id].valides) {
                    this.nb_filieres_valide++
                }
            }

            this.setDicoPhaseFilieresValidation()
        }
    }

    /** Initialise l'objet dicoPhaseFilieresValidation qui permettra d'alimenter la liste des phaseFilières proposées pour la validation des ajustements. */
    setDicoPhaseFilieresValidation() {
        this.dicoPhaseFilieresValidation = {}

        Object.keys(this.dicoPhaseFilieres).forEach(key =>  {
            const item = this.dicoPhaseFilieres[key]
            if (item.phase.ajustements) {
                if (item.concours.length === 1) {
                    this.dicoPhaseFilieresValidation[key] = item
                }
            }
        })
        Object.keys(this.dicoPhaseFilieres).forEach(key =>  {
            const item = this.dicoPhaseFilieres[key]
            if (item.phase.ajustements) {
                if (item.concours.length > 1) {
                    for (let i = 0; i < item.concours.length; i++) {
                        if (this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name]) {
                            this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].nbEpreuves = this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].nbEpreuves + item.nbEpreuves
                            this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].nbEpreuvesAjustementValide = this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].nbEpreuvesAjustementValide + item.nbEpreuvesAjustementValide
                            for (const etape_ajustement in item.liste_etapes_ajustement) {
                                if (this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].liste_etapes_ajustement[etape_ajustement]) {
                                    this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].liste_etapes_ajustement[etape_ajustement].epreuves = this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].liste_etapes_ajustement[etape_ajustement].epreuves.concat(item.liste_etapes_ajustement[etape_ajustement].epreuves)
                                } else {
                                    this.dicoPhaseFilieresValidation[item.phase.id + '-' + item.concours[i].name].liste_etapes_ajustement[etape_ajustement] = item.liste_etapes_ajustement[etape_ajustement]
                                }
                            }
                        }
                    }
                }
            }
        })
    }

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setFiltersForGenericTab() {
        const options_filieres = []

        const filieres: any = _.orderBy(this.$store.getters['concour/banques'], 'ordre', 'asc')
        for (const f in filieres) {
            options_filieres.push({ index: filieres[f].id, name: filieres[f].name })
        }

        const options_phase = [
            { index: 'admissibilite', name: 'Admissibilité' },
            { index: 'admission', name: 'Admission' }
        ]

        this.filtres = [
            { libelle: 'Phases', defautOptionlibelle: 'Toutes les', model: 'epreuve_correction.phase.name', value: '-', index: '', datas: options_phase, loading: false, options: { type: 'deroulant', fieldsKey: 'epreuve_correction.phase.name' } },
            { libelle: 'Filière', defautOptionlibelle: 'Rechercher une', model: 'epreuveCorrectionConcoursId', value: '-', index: 'name', datas: options_filieres, loading: false, options: { type: 'deroulant', fieldsKey: 'epreuve_correction.concours.name' } },
            { libelle: 'Epreuve de correction', defautOptionlibelle: 'Rechercher une', model: 'epreuve_correction.name', value: '', index: 'name', datas: null, loading: false, options: { type: 'form', fieldsKey: 'epreuve_correction.name' } }
        ]
        if (localStorage) {

            setTimeout(() => {
                const exaGenTab: any = this.$refs['genericTableListeEpreuveCorrectionResultats'] as ExaGenericTable
                exaGenTab.setFiltres(JSON.parse(localStorage.paramsListeEpreuveCorrectionResultatsFiltre))
            }, 500)
        }
    }

    /**
     * Récupération des events du tableau
     * params[0] => l'action
     * params[1] => l'id de l'item
     */
    handleTableEvent (paParams: any): void {
        if (paParams && paParams[0] && paParams[1])
        {
            switch (paParams[0])
            {
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break
                case 'detailAjustement':
                    this.$router.push('/liste_epreuve_correction_resultats/' + paParams[1])
                    break

                default:
                    break
            }
        }
    }

    /**
     * Récupération sur le serveur des 100 premiers epreuveCorrectionResultats s'ils ne sont pas déja
     * présents dans le state
     */
    loadEpreuveCorrectionResultatIfNotExists ()
    {
        this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultats').then(() => {
            this.tableLoading = false
            this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats)
            this.setFiltersForGenericTab()
        }).catch((error) => {
            console.log('ko:' + error)
        })
    }

    /**
     * Appel d'une nouvelle page de epreuveCorrectionResultats lors du scroll
     */
    filtreSortHandler (params: any)
    {
        if (this.firstLoading) {
            this.firstLoading = false
            return
        }
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            if (window && window.localStorage) {
                window.localStorage.setItem('paramsListeEpreuveCorrectionResultats', JSON.stringify(params))
                const exaGenTab: any = this.$refs['genericTableListeEpreuveCorrectionResultats'] as ExaGenericTable
                window.localStorage.setItem('paramsListeEpreuveCorrectionResultatsFiltre', JSON.stringify(exaGenTab.getFiltres()))

            }
            this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultat = []
            this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats)
            this.params = params
            this.tableLoading = true
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultats', this.params).then(() => {
                this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats)
                this.tableLoading = false
            }).catch((error) => {
                console.log('ko:' + error)
            })
        }
    }

    loadHandler (params: any) {
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            if (window && window.localStorage) {
                window.localStorage.setItem('paramsListeEpreuveCorrectionResultats', JSON.stringify(params))
                const exaGenTab: any = this.$refs['genericTableListeEpreuveCorrectionResultats'] as ExaGenericTable
                window.localStorage.setItem('paramsListeEpreuveCorrectionResultatsFiltre', JSON.stringify(exaGenTab.getFiltres()))
            }
            this.params = params
            this.tableLoading = true
            this.$store.dispatch('epreuveCorrectionResultat/getMoreEpreuveCorrectionResultats', this.params).then(() => {
                this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats)
                this.tableLoading = false
            }).catch((error) => {
                console.log('ko:' + error)
            })
        }
    }

    load () {
        this.tableLoading = true
        this.filtres = []
        this.$store.dispatch('session/getSession', { session_id: this.$store.getters['auth/user_session_id'] }).then(() => {
            this.$store.dispatch('concour/getConcoursActifs')
            this.sessionSelect = this.$store.state.session.sessionSelect
            this.$store.dispatch('concourPhase/getConcourPhases', { 'filter-ajustement': 1 }).then(() => {
                this.loadEpreuveCorrectionResultatIfNotExists()
                this.firstLoading = true
            })
        })
    }

    mounted() {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            this.load()
        }
    }
}
